import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../utils/constants';

/**
 * Singleton Supabase client.
 *
 * SECURITY (AGENTS.md §5):
 *  - Only the public ANON key is used here — it is safe to expose in the browser.
 *  - The service-role key MUST NEVER be used on the frontend.
 *    It belongs exclusively in server-side environments (Edge Functions / FastAPI).
 */

// Warn loudly in dev; in production a missing key will cause API calls to fail
// gracefully (with proper error messages) rather than crashing the whole app.
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error(
    '[PetNoter] ⚠️ Missing Supabase environment variables.\n' +
    'Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.'
  );
}

export const supabase = createClient(
  SUPABASE_URL  || 'https://placeholder.supabase.co',
  SUPABASE_ANON_KEY || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
